export const blockIconsAudioandvideoFastForwardNew = (
	<span className='material-symbols-outlined'>fast_forward</span>
);
